import $ from "jquery";

export default function(ev) {
	var store = ev.data;
	var data = {};
	var name;
	if(this.type === "checkbox") {
		name = this.name;
		data[name] = getCheckboxValuesByName(name);
		store.state.set(data);
		return data;
	} else if (this.type === "radio") {
		name = this.name;
		data[name] = getRadioValueByName(name);
		store.state.set(data);
		return data;
	} else if (this.tagName === "SELECT") {
		if (ev.type === "click") {
			return;
		} else if (ev.type === "change"){
			data[this.name] = this.value;
			store.state.set(data);
			return data;
		}
	} else if (ev.type === "submit" || ev.type === "focusout") {
		var target = $(this).find("input")[0];
		data[target.name] = target.value;
		ev.preventDefault();
		store.state.set(data);
		return data;
	} else {
		ev.preventDefault();
		data = $(this).data("state");
		store.state.set(data);
		return data;
	}
}

function getCheckboxValuesByName(name) {
	var values = [];
	var nodes = document.querySelectorAll("input[name='"+ name +"']");
	for (var i = 0; i < nodes.length; i++) {
		if (nodes[i].checked) {
			values.push(nodes[i].value);
		}
	}
	return values;
}

function getRadioValueByName(name) {
	var nodes = document.querySelectorAll("input[name='"+ name +"']");
	for (var i = 0; i < nodes.length; i++) {
		if (nodes[i].checked) {
			return nodes[i].value;
		}
	}
}




// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/modules/set-state.js